import { observer } from 'mobx-react';
import RegistrationLayout from './components/RegistrationLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import {SYSTEM_PATH} from '../../core/configs/constants';

const RegistrationThirdStepScreen = observer(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const isPendingApproval = !!location?.state?.pendingApproval;
    return (
        <RegistrationLayout>
            <div className="content-trgisstration-3">
                <div className="icon">
                    <img src="/images/v2.svg" alt="" />
                </div>
                {isPendingApproval ? (
                    <>
                        <p className="desc">ご登録いただきありがとうございます。<br />現在、ご所属法人管理者様の承認待ちの状態となります。<br />管理者様の承認が完了し次第、メールにてお知らせいたします。</p>
                        <p className="note-pending">※現在、管理者による承認が完了するまではログインできません。</p>
                        <button onClick={()=> navigate(SYSTEM_PATH.HOME)}>トップページへ戻る</button>
                    </>
                ) : (
                    <>
                        <p className="desc">ご登録いただきありがとうございます。<br /> 登録メールアドレス完了メールを送信しました。</p>
                        <button onClick={()=> navigate(SYSTEM_PATH.LOGIN)}>ログイン</button>
                    </>
                )}
            </div>
        </RegistrationLayout>
    )
})

export default RegistrationThirdStepScreen;